// extracted by mini-css-extract-plugin
export default {"undoBtn":"UndoActions_undoBtn__pTMr0","disabled":"UndoActions_disabled__SBhTH"};